var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "entry-page" },
    [
      _c("NavBar"),
      _c("div", { staticClass: "about-page" }, [
        _vm.carousel[0]
          ? _c(
              "section",
              { staticClass: "carouselStyle" },
              [
                _c("img", {
                  staticClass: "computer",
                  staticStyle: { opacity: "0" },
                  attrs: { src: _vm.carousel[0].BannerPic, alt: "" },
                }),
                _c("img", {
                  staticClass: "mobile",
                  staticStyle: { opacity: "0" },
                  attrs: { src: _vm.carousel[0].BannerPicMobile, alt: "" },
                }),
                _c(
                  "el-carousel",
                  { attrs: { interval: 5000, arrow: "always" } },
                  _vm._l(_vm.carousel, function (item) {
                    return _c("el-carousel-item", { key: item.Guid }, [
                      _c("img", {
                        staticClass: "computer",
                        attrs: { src: item.BannerPic, alt: "" },
                      }),
                      _c("img", {
                        staticClass: "mobile",
                        attrs: { src: item.BannerPicMobile, alt: "" },
                      }),
                    ])
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c("div", {
          staticStyle: { "background-color": "#fff", height: "30px" },
        }),
        _c("section", { staticClass: "job-section" }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [_vm._v(_vm._s(_vm.i18n("Homepage.JobOpenings")))]),
          ]),
          _c(
            "div",
            { staticClass: "job-list" },
            [
              _c(
                "div",
                { staticClass: "row", staticStyle: { "margin-bottom": "5px" } },
                [
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.searchCondition.manpowerDemandName,
                          expression: "searchCondition.manpowerDemandName",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      staticStyle: { "margin-bottom": "5px" },
                      attrs: {
                        type: "text",
                        placeholder: _vm.i18n("Homepage.Keyword"),
                      },
                      domProps: {
                        value: _vm.searchCondition.manpowerDemandName,
                      },
                      on: {
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.getJobList.apply(null, arguments)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.searchCondition,
                            "manpowerDemandName",
                            $event.target.value.trim()
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchCondition.workPlace,
                            expression: "searchCondition.workPlace",
                          },
                        ],
                        staticClass: "form-control",
                        staticStyle: { "margin-bottom": "5px" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.searchCondition,
                              "workPlace",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.i18n("Homepage.NotSpecified")) +
                              " "
                          ),
                        ]),
                        _vm._l(_vm.workPlaceList, function (item) {
                          return _c(
                            "option",
                            {
                              key: item.Guid,
                              domProps: { value: item.WorkPlaceName },
                            },
                            [_vm._v(" " + _vm._s(item.WorkPlaceName) + " ")]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-2" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm w-100",
                        staticStyle: {
                          "margin-bottom": "5px",
                          height: "37px",
                          background: "#f54c4a",
                          color: "#fff",
                        },
                        on: { click: _vm.getJobList },
                      },
                      [
                        _c("eva-icon", {
                          attrs: { name: "search-outline", fill: "#fff" },
                        }),
                        _vm._v(" " + _vm._s(_vm.i18n("Homepage.Search")) + " "),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._l(_vm.jobList, function (item) {
                return _c("div", { key: item.No, staticClass: "job" }, [
                  _c("div", { staticClass: "date" }, [
                    _c("span", { staticClass: "year" }, [
                      _vm._v(_vm._s(_vm._f("year")(item.RecruitmentDeadline))),
                    ]),
                    _c("br"),
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("date")(item.RecruitmentDeadline)) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "info" }, [
                    _c(
                      "div",
                      { staticClass: "name" },
                      [
                        _vm._v(" " + _vm._s(item.ManpowerDemandName) + " "),
                        _c("eva-icon", {
                          attrs: { name: "question-mark-circle", fill: "red" },
                          on: {
                            click: function ($event) {
                              return _vm.jobModal(item)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "tag" },
                      [
                        _vm._l(item.WorkPlace, function (place) {
                          return _c("span", { key: place }, [
                            _vm._v(_vm._s(place)),
                          ])
                        }),
                        item.WorkExperienceWhatever
                          ? _c("span", [_vm._v("工作經驗不拘")])
                          : _c("span", [
                              _vm._v(_vm._s(item.WorkExperience) + " 年"),
                            ]),
                        item.EducationDemandWhatever
                          ? _c("span", [_vm._v("學歷不拘")])
                          : _vm._l(
                              item.EducationDemand,
                              function (education, index) {
                                return _c("span", { key: index }, [
                                  _vm._v(" " + _vm._s(education) + " "),
                                ])
                              }
                            ),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "desc" }, [
                      _c("pre", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v(_vm._s(item.WorkContent)),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "edit" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        attrs: { type: "btn" },
                        on: {
                          click: function ($event) {
                            return _vm.apply(item.No)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Homepage.Recruit")) + " ")]
                    ),
                  ]),
                ])
              }),
            ],
            2
          ),
        ]),
        _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: {
              id: "jobModal",
              tabindex: "-1",
              "aria-labelledby": "jobModal",
              "aria-hidden": "true",
            },
          },
          [
            _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("span", { staticClass: "modal-title" }, [
                    _vm._v(
                      " " + _vm._s(_vm.job.ManpowerDemandName) + "-職務說明 "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "modal-body" }, [
                  _vm.job.PositionInstruction === null
                    ? _c("span", [_vm._v("尚無說明")])
                    : _c("pre", [_vm._v(_vm._s(_vm.job.PositionInstruction))]),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }